import { createReactComponent } from './react-wrapper';
import type { FrameworkAdapter, ComponentConfig } from './component-factory';

const reactAdapter: FrameworkAdapter = {
  name: 'React Adapter',
  family: 'react',
  createComponent: (config: ComponentConfig) => {
    return createReactComponent(config.tag, config.events || []);
  }
};

export default reactAdapter;
